import { render } from "./LayoutImageEditor.vue?vue&type=template&id=3a8e6edf"
import script from "./LayoutImageEditor.vue?vue&type=script&lang=js"
export * from "./LayoutImageEditor.vue?vue&type=script&lang=js"

import exportComponent from "C:\\NicolPC\\VueWork2026\\Axxo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__